<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutterr" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container-otd">

                <div class="row justify-content-md-center">
                  <div>
                    
                    
                    <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                      <vs-input label="Mot de passe" @keyup.enter="submitData" 
                      v-model="input.last_password" type="password" class="w-full" 
                      name="last_password" 
                      :danger="!!formErrors.last_password"
                      :danger-text="formErrors.last_password ? formErrors.last_password[0] : ''"
                      v-on:input="resetErrors('last_password')"/>
                    </vs-col>

                   

                    <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                      <vs-input label="Nouveau mot de passe" @keyup.enter="submitData" 
                      v-model="input.password" type="password" class="w-full" name="password" 
                      :danger="!!formErrors.password"
                      :danger-text="formErrors.password ? formErrors.password[0] : ''"
                      v-on:input="resetErrors('password')"/>
                    </vs-col>


                    <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                      <vs-input label="Confirmer le nouveau mot de passe" 
                      @keyup.enter="submitData" v-model="input.password_confirmation" 
                      type="password" class="w-full" name="password_confirmation" 
                      :danger="!!formErrors.password_confirmation"
                      :danger-text="formErrors.password_confirmation ? formErrors.password_confirmation[0] : ''"
                      v-on:input="resetErrors('password_confirmation')"/>
                    </vs-col>
                  </div>

                  
                  <div class="">
                    <vs-button class="mt-5 mb-5" @click="submitData">Valider</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
var base_self
/*var input_tempon = {
  password: '',
  last_password: '',
  password_confirmation: '',
}*/
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    base: ''
  },
  components: {
    VuePerfectScrollbar
    
  },
  watch: {
  },
  data() {
    return {
      url: '/auth/password/update',
      input: {},
      passwordEdit : false,
      settings: {
        maxScrollbarLength: 600,
        wheelSpeed: 0.6
      },
      formErrors:{}
    };
  },
  computed: {
  },
  methods: {
    resetErrors(field) {
      if (field) {
        this.formErrors[field] = null;
      } else {
        this.formErrors = [];
        Object.keys(this.input).forEach(index => (this.input[index] = null));
      }
    },
    submitData() {
      var input = JSON.parse(JSON.stringify(base_self.input))
      base_self.$vs.loading()
      
      base_self.$http.put(base_self.url, input)
      .then((response) => { 
        
        window.getApp.success("Le mot de passe a été modifié avec succès.", response)

      //if(base_self.$store.state.AppActiveUser.birthday == null){

          // base_self.$router.push('/datesUpdate').catch(() => {})
     // }
       
       })
      .catch((error) => { 
        base_self.$vs.loading.close()
        this.$vs.notify({
                title: "Erreur",
                text: "Veuilliez valider les champs du formulaire",
                color: "danger",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-alert-circle"
              });
              this.formErrors = error.response.data.errors;
       })
      
    }
  },
  created() {

    base_self = this
    console.log('base_self.$store.state.AppActiveUser : ', base_self.$store.state.AppActiveUser)
    
  
  },
  mounted() {
  }
};
</script>
